import { render, staticRenderFns } from "./QuotationResults.vue?vue&type=template&id=735df147&scoped=true&"
import script from "./QuotationResults.vue?vue&type=script&lang=js&"
export * from "./QuotationResults.vue?vue&type=script&lang=js&"
import style0 from "./QuotationResults.vue?vue&type=style&index=0&id=735df147&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735df147",
  null
  
)

export default component.exports